import { observer } from "mobx-react";
import RmaPageStore, { IRmaValidateAllAction } from "../../stores/rma-page-store";
import { ConfirmModal } from "../../../../../components/modal/components/confirm-modal/confirm-modal";
import useDashboardTranslation from "../../../../../dashboard-translation/hooks/dashboard-translation-hook";
import "./rma-action-validate-all-modal.scss";
import FontBody2 from "../../../../../components/fonts/font-body2/font-body2";
import rmsMixpanelStore from "../../../../../stores/rms-mixpanel-store";

interface IProps {
	rma: RmaPageStore;
	rmaAction: IRmaValidateAllAction;
	onCloseClick: () => void;
}

const RmaActionValidateAllModal: React.FC<IProps> = observer(({rma, rmaAction, onCloseClick}) => {
	const actionStore = rmaAction.store;

	const {getTranslation} = useDashboardTranslation();
	const scope = "dashboard-returns-rma-card";

	const onSubmit = () => {
		actionStore.submitAction(() => {
			rmsMixpanelStore.trackEvent("d&_validate_all_button_confirmed", { RMAID: rma.rmaId });
			onCloseClick();
		});
	};

	return (
		<ConfirmModal
			title={getTranslation("VALIDATE_ALL", scope)}
			text={
				<div className="validate-all-action-modal">
					{!!rma.customerCaseStore?.notValidatedProductsCount &&
						(rma.customerCaseStore?.notValidatedProductsCount > 1
							? getTranslation(rmaAction.descriptionTranslationKey, scope, [
								rma.customerCaseStore.notValidatedProductsCount.toString(),
							])
							: getTranslation("VALIDATE_ALL_DESCRIPTION_SINGULAR", scope))}
					<br/>
					<FontBody2>{getTranslation("VALIDATE_ALL_ALTERNATIVE", scope)}</FontBody2>
				</div>
			}
			cancelButton={{
				title: getTranslation("CANCEL", scope),
				onClick: () => onCloseClick(),
			}}
			okButton={{
				title: getTranslation(rmaAction.buttonTextTranslationKey, scope),
				onClick: onSubmit,
				hasLoader: true,
				isLoading: actionStore.isProcessing,
			}}
		/>
	);
});

export default RmaActionValidateAllModal;
